import {Injectable} from '@angular/core';
import {SessionService} from '../../session-service/session.service';
import {AssignRespondentInput} from '../../models/Respondent';
import {AssignRespondentModel} from '../../models/assign-respondent-model';
import {
  SurveyProjectRequestDTO,
  SurveyActivityRequestDTO,
  EditSurveyProjectActivityRequestDTO,
  ProjectsDTO,
  ActivitiesDTO,
} from '../../models/edit-survey/getsurvey-projects-activity.model';
import {BehaviorSubject} from 'rxjs';
import {API_URL} from '../../constants/apiurl-constants';
import { ActivityTypeEnum } from '../../constants/activity-type.enum';

@Injectable({providedIn: 'root'})
export class AssignSurveyRespondentService {
  respondentDetails: AssignRespondentModel;
  surveyDetails: any;
  surveyDataRefresh = new BehaviorSubject({});
  refreshSurveyData = this.surveyDataRefresh.asObservable();

  constructor(private _sessionService: SessionService) {}

  getSurveyRespondent(clientID: any) {
    return this._sessionService.apiUrlGet(
      API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientID,
    );
  }

  assignSurveyRespondent(surveyRepsondent: AssignRespondentInput) {
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.ASSIGNSURVEYRESPONDENT,
      surveyRepsondent,
    );
  }

  SendEmailAssignMultipleSME(surveyData) {
    return this._sessionService.apiUrlPost(API_URL.SURVEY.SENDEMAILASSIGNMULTIPLESMES, surveyData);
  }

  AssignMultipleSME(surveyData) {
    return this._sessionService.apiUrlPost(API_URL.SURVEY.ASSIGNMULTIPLESMES, surveyData);
  }

  setAssignSurveyRepondentDatas(respondentData: any[]) {
    if (respondentData.length != 0) {
      this.respondentDetails = {
        respondentData: respondentData,
        isReassign: true,
      };
    } else {
      this.respondentDetails = {
        isReassign: false,
        respondentData: null,
      };
    }
  }

  getSurveyRepondentDatas(): AssignRespondentModel {
    return this.respondentDetails;
  }

  updateSurveyMetadata(surveyData: AssignRespondentInput) {
    return this._sessionService.apiUrlPost(
      API_URL.UPDATESURVEYMETADATA,
      surveyData,
    );
  }

  setSurveyDetails(surveyData: any) {
    if (surveyData) {
      this.surveyDetails = surveyData;
    }
  }

  getSurveyDetails() {
    return this.surveyDetails;
  }

  refreshData(surveyDetails) {
    this.surveyDataRefresh.next(this.surveyDetails);
  }

  checkSurveyNameExists(engagementId: number, surveyName: string) {
    let inputData = {
      EngagementId: engagementId,
      SurveyName: surveyName,
    };
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.CHECKSURVEYNAME,
      inputData,
    );
  }

  getUnAssignedProjectsActivities(engagementId: number, surveyId: number) {
    return this._sessionService.apiUrlGet(
      API_URL.SURVEY.GETUNASSIGNEDPROJECTSACTIVITIES +
        `?engagementId=${engagementId}&surveyId=${surveyId}`,
    );
  }

  getSurveyProjectsActivities(engagementId: number, surveyId: number) {
    return this._sessionService.apiUrlGet(
      API_URL.SURVEY.GETSURVEYPROJECTSACTIVITIES +
        `?engagementId=${engagementId}&surveyId=${surveyId}`,
    );
  }

  editSurveyProjectActivity(
    addPrjList: Array<ProjectsDTO>,
    addActList: Array<ActivitiesDTO>,
    delPrjList: Array<ProjectsDTO>,
    delActList: Array<ActivitiesDTO>,
    surveyId: number,
  ) {
    let editSurveyData: EditSurveyProjectActivityRequestDTO;
    let projectList: Array<SurveyProjectRequestDTO> = [];
    addPrjList.forEach(element => {
      if (element.projectId > 0 && surveyId > 0) {
        let input: SurveyProjectRequestDTO = {
          projectName: element.name,
          projectId: element.projectId,
          surveyId: surveyId,
        };
        projectList.push(input);
      }
    });

    let activityList: Array<SurveyActivityRequestDTO> = [];
    addActList.forEach(element => {
      if (element.activityId > 0 && surveyId > 0) {
        let input: SurveyActivityRequestDTO = {
          activityName: element.name,
          activityId: element.activityId,
          surveyId: surveyId,
        };
        activityList.push(input);
      }
    });

    let projectIds: Array<number> = [];
    delPrjList.forEach(element => {
      if (element.projectId > 0 && surveyId > 0) {
        projectIds.push(element.projectId);
      }
    });

    let activityIds: Array<number> = [];
    delActList.forEach(element => {
      if (element.activityId > 0 && surveyId > 0) {
        activityIds.push(element.activityId);
      }
    });
    let activityTypeIds: Array<number> = [];
    addActList.filter(element => element.activityType===ActivityTypeEnum.Project).length>0?activityTypeIds.push(ActivityTypeEnum.Project):0;
    addActList.filter(element => element.activityType===ActivityTypeEnum.NQA).length>0?activityTypeIds.push(ActivityTypeEnum.NQA):0;
    addActList.filter(element => element.activityType===ActivityTypeEnum.NWT).length>0?activityTypeIds.push(ActivityTypeEnum.NWT):0;
    addActList.filter(element => element.activityType===ActivityTypeEnum.Activity).length>0?activityTypeIds.push(ActivityTypeEnum.Activity):0;
   
    editSurveyData = {
      ProjectList: projectList,
      ActivityList: activityList,
      ProjectIds: projectIds,
      ActivityIds: activityIds,
      SurveyId: surveyId,
      EngagementId: Number(this._sessionService.getSession('engagementId')),
      ActivityTypeIds: activityTypeIds.length>0?activityTypeIds:[]
    };

    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.EDITSURVEYPROJECTACTIVITY,
      editSurveyData,
    );
  }

}
